/* rxlib - ButtonSplit v2.0.0 */

import Spinner from '../../spinner';
import { ButtonClassStyle } from '../button';

export interface ButtonSplitItem {
    link: string;
    texto: string;
}

export interface ButtonSplitProps {
    texto: string;
    className?: string;
    carregando?: boolean;
    itens: ButtonSplitItem[];
    fontAwesomeIcon?: string;
    classNameDivSpinner?: string;
    classStyle: ButtonClassStyle;
}

export default function ButtonSplit({
    texto,
    itens,
    className,
    carregando,
    fontAwesomeIcon,
    classNameDivSpinner,
    classStyle = 'btn-rxlib',
}: ButtonSplitProps) {
    let classNameButtonSplit: string = 'btn rxlib-btn ' + classStyle;
    if ((className) && (className !== '')) {
        classNameButtonSplit = className + ' ' + classNameButtonSplit;
    }

    return (
        <>
            {
                (carregando)
                    ? <Spinner
                        classStyle='rxlib-spinner'
                        classNameDiv={classNameDivSpinner} />
                    : <div className='rxlib-button-split'>
                        <div className='btn-group'>
                            <button type='button' className={'rxlib-button-split-01 ' + classNameButtonSplit}>
                                {
                                    (fontAwesomeIcon)
                                        ? <i className={fontAwesomeIcon}></i>
                                        : texto
                                }
                            </button>
                            <button type='button' className={'rxlib-button-split-02 ' + classNameButtonSplit + ' dropdown-toggle dropdown-toggle-split'} data-bs-toggle='dropdown' aria-expanded='false'>
                                <span className='visually-hidden'>Toggle Dropdown</span>
                            </button>
                            <ul className='dropdown-menu'>
                                {
                                    itens.map((item, index) =>
                                        item.link !== ''
                                            ? <li key={index}><a className='dropdown-item' href={item.link}>{item.texto}</a></li>
                                            : ''
                                    )
                                }
                            </ul>
                        </div>
                    </div>
            }
        </>
    );
}